import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => (

 <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"

    style={{ marginLeft: '12px', marginRight: '10px' }}

    {...props}
  >
    <g clipPath="url(#clip0_710_3033)">
      <path
        d="M13.7929 7.56302L9.15 5.62785C9.10299 5.6082 9.0518 5.59802 9 5.59802C8.9482 5.59802 8.89701 5.6082 8.85 5.62785L4.20714 7.56302C4.14515 7.58893 4.09269 7.63035 4.05597 7.68238C4.01926 7.7344 3.99983 7.79484 4 7.85652V13.3395C3.99983 13.4012 4.01926 13.4616 4.05597 13.5137C4.09269 13.5657 4.14515 13.6071 4.20714 13.633L8.85 15.5682C8.89701 15.5878 8.9482 15.598 9 15.598C9.0518 15.598 9.10299 15.5878 9.15 15.5682L13.7929 13.633C13.8548 13.6071 13.9073 13.5657 13.944 13.5137C13.9807 13.4616 14.0002 13.4012 14 13.3395V7.85652C14.0002 7.79484 13.9807 7.7344 13.944 7.68238C13.9073 7.63035 13.8548 7.58893 13.7929 7.56302ZM9 9.43692L5.21072 7.85652L9 6.27613L12.7893 7.85652L9 9.43692ZM13.2857 13.1331L9.35714 14.7715V9.99812L13.2857 8.35967V13.1331Z"
        fill="url(#paint0_linear_710_3033)"
      />
      <path
        d="M15.3637 2.73436C13.6635 1.03421 11.4046 0.0980225 9 0.0980225C6.59542 0.0980225 4.33557 1.03421 2.63634 2.73436C0.936183 4.43451 0 6.69436 0 9.09802C0 10.6837 0.407634 12.207 1.17344 13.5481C1.23023 13.647 1.28885 13.745 1.34931 13.8421C1.56275 14.1857 1.80092 14.5154 2.06198 14.8305C2.20855 15.0083 2.36336 15.1805 2.52458 15.3472C2.56122 15.3857 2.59878 15.4241 2.63634 15.4617C3.20428 16.0296 3.83542 16.5124 4.51328 16.9035C4.70931 17.0162 4.90901 17.1215 5.11237 17.2195C5.4458 17.3789 5.7884 17.5182 6.13924 17.6354C6.31969 17.6959 6.5029 17.7499 6.68794 17.7985C7.43267 17.9954 8.20855 18.098 9 18.098C11.2076 18.098 13.2925 17.3084 14.935 15.8638C15.0128 15.7951 15.0898 15.7246 15.1658 15.6531C15.2327 15.5908 15.2986 15.5267 15.3637 15.4617C15.4269 15.3985 15.4892 15.3344 15.5496 15.2702C15.6174 15.1988 15.6834 15.1255 15.7484 15.0522C15.938 14.8379 16.1176 14.6153 16.2843 14.3854C16.3392 14.3112 16.3924 14.236 16.4437 14.1591C16.5371 14.0226 16.6269 13.8843 16.7121 13.7432C16.7606 13.6635 16.8064 13.5847 16.8522 13.5041C17.6015 12.1731 18 10.6663 18 9.09802C18 6.69436 17.0638 4.43451 15.3637 2.73436ZM16.6397 11.2104C16.615 11.302 16.5893 11.3927 16.5609 11.4834C16.5105 11.6437 16.4537 11.8021 16.3933 11.9588C16.3594 12.0458 16.3246 12.1328 16.2879 12.218C16.1725 12.4883 16.0406 12.7521 15.895 13.0086C15.8492 13.0883 15.8024 13.1689 15.7539 13.2476C15.666 13.3896 15.5734 13.5289 15.4763 13.6663C15.4214 13.7441 15.3655 13.8202 15.3078 13.8962C15.0971 14.1719 14.8681 14.4357 14.6198 14.6849C14.6144 14.6904 14.6098 14.6968 14.6043 14.7023C14.5319 14.7747 14.4577 14.8434 14.3826 14.913C14.2269 15.0577 14.0656 15.1951 13.8998 15.3261C13.7973 15.4067 13.6928 15.4855 13.5866 15.5606C12.2556 16.5096 10.6681 17.0235 9 17.0235C8.87359 17.0235 8.74809 17.0199 8.62168 17.0144C8.4513 17.0061 8.28183 16.9915 8.11328 16.9731C7.81191 16.9392 7.5142 16.8889 7.22198 16.822C7.0571 16.7844 6.89313 16.7423 6.73099 16.6947C6.09069 16.5041 5.47695 16.233 4.90443 15.8858C4.74321 15.7887 4.58657 15.6834 4.43267 15.5744C4.14504 15.371 3.87023 15.1475 3.60824 14.9038C3.53679 14.8379 3.46534 14.771 3.39573 14.7023C3.32244 14.6281 3.25191 14.5521 3.18137 14.476C2.75634 14.0171 2.39176 13.5151 2.09038 12.982C2.01252 12.8428 1.93832 12.7026 1.8687 12.5606C1.74687 12.3105 1.63786 12.055 1.54351 11.7939C1.49679 11.6647 1.45374 11.5337 1.41344 11.4028C1.19084 10.6654 1.0745 9.89039 1.0745 9.09802C1.0745 6.98108 1.89893 4.99054 3.39573 3.49375C4.89344 1.99695 6.88305 1.17253 9 1.17253C11.1169 1.17253 13.1075 1.99695 14.6043 3.49375C16.1011 4.99146 16.9255 6.98108 16.9255 9.09802C16.9255 9.82169 16.8266 10.5307 16.6397 11.2104Z"
        fill="url(#paint1_linear_710_3033)"
      />
      <path
        d="M10 3.59802C10 3.68042 9.9488 3.74962 9.8696 3.77362C9.4472 3.90242 9.3044 4.04522 9.1756 4.46802C9.1516 4.54682 9.0824 4.59802 9 4.59802C8.9176 4.59802 8.8484 4.54682 8.8244 4.46802C8.6956 4.04522 8.5528 3.90242 8.13 3.77362C8.0512 3.74962 8 3.68042 8 3.59802C8 3.51562 8.0512 3.44642 8.13 3.42242C8.5528 3.29362 8.6956 3.15082 8.8244 2.72802C8.8484 2.64922 8.9176 2.59802 9 2.59802C9.0824 2.59802 9.1516 2.64922 9.1756 2.72802C9.3044 3.15082 9.4472 3.29362 9.87 3.42242C9.9488 3.44642 10 3.51562 10 3.59802Z"
        fill="url(#paint2_linear_710_3033)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_710_3033"
        x1="9.00182"
        y1="3.89291"
        x2="9.00182"
        y2="20.9878"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A088F2" />
        <stop offset="1" stopColor="#524FFB" />
        <stop offset="1.0001" stopColor="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_710_3033"
        x1="9.00327"
        y1="-2.97117"
        x2="9.00327"
        y2="27.7996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A088F2" />
        <stop offset="1" stopColor="#524FFB" />
        <stop offset="1.0001" stopColor="#524FFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_710_3033"
        x1="9.00036"
        y1="2.257"
        x2="9.00036"
        y2="5.67598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A088F2" />
        <stop offset="1" stopColor="#524FFB" />
        <stop offset="1.0001" stopColor="#524FFB" />
      </linearGradient>
      <clipPath id="clip0_710_3033">
        <rect width="18" height="18" fill="white" transform="translate(0 0.0980225)" />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
